import { API_TYPE } from '@umu/umu-fetch';
export const API = {
    GET_KNOWLEDGE_DEPARTMENT_LIST: {
        url: `/uapi/v1/knowledge-point-data/department-and-user-list`, //知识点-部门组织架构
        type: API_TYPE.GET,
    },
    GET_KNOWLEDGE_DEPARTMENT_SEARCH_LIST: {
        url: `/uapi/v1/knowledge-point-data/search-department-and-user`, //知识点-部门组织架构 搜索
        type: API_TYPE.GET,
    },
    GET_WORKSPACE_DEPARTMENT_LIST: {
        url: `/uapi/v1/mytodo/get-department-list`,
        type: API_TYPE.GET,
    },
    GET_WORKSPACE_DEPARTMENT_SEARCH_LIST: {
        url: `/uapi/v1/department/sug`,
        type: API_TYPE.GET,
    },
};
